/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedBlurbShipping_user = {
    readonly isVerifiedTrade: boolean | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedShippingInfoLink_user">;
    readonly " $refType": "PdpSharedBlurbShipping_user";
};
export type PdpSharedBlurbShipping_user$data = PdpSharedBlurbShipping_user;
export type PdpSharedBlurbShipping_user$key = {
    readonly " $data"?: PdpSharedBlurbShipping_user$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedBlurbShipping_user">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedBlurbShipping_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isVerifiedTrade",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedShippingInfoLink_user",
      "args": null
    }
  ]
};
(node as any).hash = '692ffbf80bf5c2738dee5a2bebd95949';
export default node;
